import {dataSidebar} from "./dataSidebar";
import WebLogo from '../../assets/image/webLogo.png'
import {useLocation, useNavigate} from "react-router-dom";


export default function SideBar({setShowMenuMobile}) {

    const navigate = useNavigate();
    const location = useLocation();

    return (

        <div className={`max-h-screen overflow-y-auto overflow-x-hidden`}>

            <div className="flex items-center gap-3 justify-center">
                <img src={WebLogo} alt="logo" height={42} width={42}/>
                <div className="text-[32px] text-white italic flex items-center justify-center">
                    <span>clan</span>
                    <b className="font-bold text-buttonColor-shade6 text-[54px]">s</b>
                    <span>mart</span>
                </div>
            </div>


            <ul className="flex flex-col gap-1 text-xl mt-3">
                {dataSidebar.map(item =>
                    <li className={`flex py-2 px-5 gap-2 items-center ${location.pathname === item.link ? "text-bg-secondColor-shade7 bg-white" : "text-white hover:translate-x-3"} duration-500 hover:cursor-pointer`}
                        key={item.link}
                        onClick={() => {navigate(item.link); setShowMenuMobile?.(false)}}
                    >
                        {item.icon}
                        {item.title}
                    </li>
                )}
            </ul>


        </div>
    )
}